export enum SCRIPT_PRECHECK_STATUS_MESSAGE {
  STARTING = 'Starting precheck...',
  SUCCESSFULL = 'Precheck completed successfully',
  ERROR = 'There was a problem found during precheck'
}

export enum SCRIPT_STATUS_MESSAGE {
  STARTING = 'Saving script...',
  SUCCESSFULL = 'Script saved successfully',
  ERROR = 'There was a problem found while saving script'
}

export const TemporaryScriptSuffix = '_precheck';

export interface IApplicationServers {
  id?: number;
  hostName: string;
  ips: Array<string>;
  ports: Array<IPort>;
  ipProtocols: Array<string>;
}

export interface IPort {
  portValueType: string;
  first: number;
  last: number;
  fixed: number;
}

export interface IApplication {
  id: number;
  description: string;
  url: string;
  curlUrl?: string;
  name: string;
  applicationType?: string;
  appDependencies: Array<any>;
  applicationServers: Array<IApplicationServers>;
  iconUrl: string;
  combinedAppServer?: ICombineAppServers;
  deleted?: boolean;
}

export interface ICombineAppServers {
  ips: Array<string>;
  ports: Array<string>;
  protocols: Array<string>;
}

export interface IApplicationId {
  id: number;
}
